import { Package } from "lucide-react";
import { StampSvg } from "@/components/StampSvg";
import { computeLayout, initialDesign } from "@/lib/layout";
import { useMeta } from "@/lib/meta";
import { fileUrl } from "@/components/ProductGallery";

export const sizeLabel = (p) => (p.shape === "round" ? `Ø ${p.width_mm} mm` : `${Math.min(p.width_mm, p.height_mm)}×${Math.max(p.width_mm, p.height_mm)} mm`);

export function ProductThumb({ p, w = 200, h = 120 }) {
  const meta = useMeta();
  if (p.kind === "pad") {
    return p.image ? <img src={fileUrl(p.image)} alt={p.name} className="max-w-full max-h-full object-contain" style={{ maxHeight: h }} />
      : <Package className="text-brand-navy" style={{ width: Math.min(w, h) * 0.5, height: Math.min(w, h) * 0.5 }} />;
  }
  if (!meta) return null;
  return <StampSvg layout={computeLayout(p, initialDesign(p))} color="#1D4ED8" scale={Math.min(w / p.width_mm, h / p.height_mm)} className="drop-shadow-md" />;
}
